import ScrollTriggerClass from './ScrollTriggerClass'

export default class {
  constructor() {

    const domScrollTriggerClass = document.querySelectorAll('[data-trigger="stc"]');
    if (domScrollTriggerClass) new ScrollTriggerClass(domScrollTriggerClass);  
  }
}
